module.exports = __webpack_public_path__ + "media/images/games/k2reveal/dog-18460d58780f9699b4490d4d16ea2454.png";